import React, { useState } from "react";
import HomeHeader from "../home/HomeHeader";
import { queryTypes, useQueryState } from "next-usequerystate";
import LoginComponent from "../home/LoginComponent";
import InvestorsHero from "./InvestorsHero";
// import InvestorsQuestions from "./InvestorsQuestions";
import FeaturesSection from "../sponsors/FeaturesSection";
import features_1 from "public/marketing/investors/features/features_1.png";
import features_2 from "public/marketing/investors/features/features_2.png";
import performancemonitoring from "public/marketing/investors/features/performancemonitoring.png";
import features_4 from "public/marketing/sponsors/features/features_4.png";
import MiniFeaturesSection from "../sponsors/MiniFeaturesSection";
import list from "public/marketing/sponsors/accelerators/list.svg";
import chatGpt from "public/marketing/sponsors/accelerators/chat_gpt.svg";
import files from "public/marketing/sponsors/accelerators/files.svg";
import BookDemoSection from "../sponsors/BookDemoSection";

const Investors = () => {
  const [showLoginUrl] = useQueryState("login", queryTypes.boolean);
  const [showLogin, setShowLogin] = useState(showLoginUrl);

  return (
    <div className="w-full bg-white">
      <LoginComponent show={showLogin} setShow={setShowLogin} />
      <HomeHeader setShow={setShowLogin} />
      <InvestorsHero />
      <FeaturesSection
        headerText={"Bring order to your private investments"}
        subtitleText={
          "Say goodbye to scattered investments, disorganized data, and limited visibility."
        }
        linkId="features"
        features={[
          {
            title: "Understand your portfolio’s performance",
            description:
              "Finally have visibility into your portfolio’s performance. Gain clarity around when distributions are expected and plan accordingly.",
            image: performancemonitoring,
          },
          {
            title: "Organize everything in one place",
            description:
              "It only takes a few minutes to add your portfolio. For your investments, you can log distributions, upload deal docs, add your notes and more.",
            image: features_2,
          },
          {
            title: "Understand deals better with the help of AI",
            description:
              "Get your questions answered instantly, in natural language and backed with clickable references, from our ChatGPT-powered assistant.",
            image: features_4,
          },
          {
            title: "No more manual tracking",
            description:
              "Configure your email inbox to automatically keep your portfolio updated. Elmbase's AI processes email updates, automatically logs distributions, alerts you when a deal isn’t going according to plan.",
            image: features_1,
          },
        ]}
      />
      <MiniFeaturesSection
        headerText={"Grow your network"}
        linkId={"network"}
        subtitleText={
          "Access the best deals from the best sponsors. Vetted by people you know."
        }
        miniFeatures={[
          {
            title: "Foster relationships with sponsors",
            description:
              "Connect with sponsors that you know and learn more about them and their teams.",
            image: list,
          },
          {
            title: "Receive and make referrals",
            description:
              "Exchange referrals with your connections and discover deals within your network.",
            image: chatGpt,
          },
          {
            title: "Analyze live deals",
            description:
              "Leverage tools like ChatGPT to help understand and assess deals that you're invited to on Elmbase.",
            image: files,
          },
        ]}
      />
      {/* <InvestorsQuestions /> */}
      <BookDemoSection
        headerText={"Data privacy"}
        subtitleText={
          "Elmbase keeps your data confidential, and will never share your data without your explicit consent."
        }
        showDemoButton={false}
      />
    </div>
  );
};

export default Investors;
